import React, {Component} from 'react';
import {connect} from 'react-redux';
import Const from 'constants';

class LineupPlayerFinalHeadComponent extends Component {
    canComponentBeRendered() {
        const {sportConfig} = this.props;

        return sportConfig.isModeBacktest();
    }

    render() {
        if (!this.canComponentBeRendered()) {
            return null;
        }

        const {lineup} = this.props;

        return (
            <li>
                <strong>Final:</strong> {lineup.totalFinalPoints}
            </li>
        );
    }
}

function mapStatesToProps(state) {
    const {sportConfig} = state;

    return {
        sportConfig,
    };
}

const LineupPlayerFinalHead = connect(mapStatesToProps)(LineupPlayerFinalHeadComponent);

export {LineupPlayerFinalHead};
